import '../../../../styles/knowledge-concept/flashcard/FlashCard.css';

import {
	FaAngleDoubleLeft,
	FaAngleDoubleRight,
	FaArrowLeft,
	FaArrowRight,
	FaChevronLeft,
	FaChevronRight,
} from 'react-icons/fa';
import { MathJax, MathJaxContext } from 'better-react-mathjax'; // Import MathJax
import React, { useEffect, useRef, useState } from 'react';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';

import AICreatedFlashcard from './AICreatedFlashcard';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FlashcardForm from './FlashcardForm';
import SelfCreateFlashcard from './SelfCreateFlashcard';
import { logger } from '../../../../utils/logger';
import { useSelector } from 'react-redux';
import userIcon from '../../../../assets/user_profile.svg';

import { updateXPMetrics } from '../../../../services/UsersApi';

const Flashcard = ({
	flashcard_data,
	boxId,
	topicId,
	subtopicId,
	subject,
	newBoxId,
	isNewBox,
	ai_content_data,
}) => {
	const [flashcards, setFlashcards] = useState([]);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isFlipped, setIsFlipped] = useState(false);
	const flashcardRef = useRef(null);
	const selectedSubTopicDetails = useSelector(
		(state) => state.selectedSubTopic.selectedSubTopicData
	);
	const { userId, firstName } = useSelector((state) => state.userDetails);

	const flashcardsData = useSelector((state) => state.flashcard?.flashcardList || []);

	let notebookId = selectedSubTopicDetails?.notebookId;
	let topicName = selectedSubTopicDetails?.topicName;
	let subtopicName = selectedSubTopicDetails?.subtopicName;
	flashcard_data = flashcard_data[0];
	let [selfCreated, setSelfCreated] = useState(false);
	let [aiCreated, setAICreated] = useState(false);
	let [showCreateOptions, setShowCreateOptions] = useState(false);
	const [showFlashcardForm, setShowFlashcardForm] = useState(false);
	const [flashcardFormData, setFlashcardFormData] = useState([]);
	const [isAiGeneratedFlashcardSaved, setIsAIGeneratedSaved] = useState(false);
	const [activeBoxId, setActiveBoxId] = useState(null);
	const [slideDirection, setSlideDirection] = useState(''); // NEW
	const contentRef = useRef(null);
	const textRef = useRef(null);
	const [isOverflowing, setIsOverflowing] = useState(false);
	const [reviewedIndexes, setReviewedIndexes] = useState(new Set());
	const xpQueue = useRef(0);
	const debounceTimeout = useRef(null);

	const resetFlip = () => {
		const card = flashcardRef.current;
		if (card) {
			card.style.transition = 'none';
			card.classList.remove('flipped');
			requestAnimationFrame(() => {
				card.style.transition = 'transform 0.6s';
			});
		}
		setIsFlipped(false);
	};

	useEffect(() => {
		requestAnimationFrame(() => {
			if (textRef.current) {
				const height = textRef.current.offsetHeight;
				const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight, 10) || 24;
				const numLines = height / lineHeight;
				setIsOverflowing(numLines > 6); // Adjust 6 to define when it's "long"
			}
		});
	}, [currentIndex, isFlipped]);

	useEffect(() => {
		if (!isNewBox) {
			logger.log('Flashcard data inside useEffect: ', flashcard_data);
			if (flashcard_data && flashcard_data.length > 0) {
				const newFlashcards = flashcard_data.map((card) => ({
					content: {
						front: card.question,
						back: card.answer,
						type: card.type,
					},
				}));

				setFlashcards(newFlashcards);
				logger.log('1 Flashcards inside useEffect: ', flashcards);
			}
		} else {
			setShowCreateOptions(true);
			setActiveBoxId(newBoxId);
		}
	}, [flashcard_data, isNewBox]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (window.MathJax && contentRef.current) {
				window.MathJax.typesetPromise([contentRef.current])
					.then(() => console.log('Flashcard MathJax typeset completed'))
					.catch((err) => console.error('Flashcard MathJax typesetting failed:', err));
			}
		}, 100);

		return () => clearTimeout(timeout);
	}, [currentIndex, isFlipped]);

	const handleCreateNew = (boxId) => {
		setActiveBoxId(boxId);
		setShowCreateOptions(true);
		setSelfCreated(false);
	};

	/*useEffect(() => {
		if (flashcards.length > 0 && !reviewedIndexes.has(0)) {
			setReviewedIndexes((prev) => new Set(prev).add(0));
			xpQueue.current += 1;

			if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

			debounceTimeout.current = setTimeout(() => {
				if (xpQueue.current > 0) {
					updateXPMetrics(userId, 'FLASHCARD', xpQueue.current);
					xpQueue.current = 0;
				}
			}, 2000);
		}
	}, [flashcards]);*/

	const handleNext = async () => {
		if (currentIndex < flashcards.length - 1) {
			const nextIndex = currentIndex + 1;
			if (!reviewedIndexes.has(nextIndex)) {
				setReviewedIndexes((prev) => new Set(prev).add(nextIndex));
				xpQueue.current += 1;

				// Debounce API call
				if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

				debounceTimeout.current = setTimeout(() => {
					if (xpQueue.current > 0) {
						updateXPMetrics(userId, 'FLASHCARD', xpQueue.current);
						xpQueue.current = 0;
					}
				}, 2000); // 2 seconds idle
			}
			setSlideDirection('right');
			setCurrentIndex((prevIndex) => prevIndex + 1);
			resetFlip();
		}
	};

	const handlePrevious = () => {
		if (currentIndex > 0) {
			setSlideDirection('left');
			setCurrentIndex((prevIndex) => prevIndex - 1);
			resetFlip();
		}
	};

	const handleSkipToFirst = () => {
		setCurrentIndex(0);
		resetFlip();
		setSlideDirection('left');
	};

	const handleSkipToLast = () => {
		setCurrentIndex(flashcards.length - 1);
		resetFlip();
		setSlideDirection('right');
	};

	const handleFlip = () => {
		setIsFlipped(!isFlipped);
	};

	const handleCreateFlashcard = (buttonIdentifier) => {
		if (buttonIdentifier === 'self') {
			setSelfCreated(true);
			setShowCreateOptions(false);
			setAICreated(false);
		} else if (buttonIdentifier === 'ai') {
			setSelfCreated(false);
			setShowCreateOptions(false);
			setAICreated(true);
		}
	};

	const handleFlashcardSaved = (flashcard_data) => {
		const newFlashcards = flashcard_data.map((card) => ({
			content: {
				front: card.question,
				back: card.answer,
				type: card.type,
			},
		}));
		setFlashcards((prev) => {
			const updatedFlashcards = [...prev, ...newFlashcards];
			return updatedFlashcards;
		});
		logger.log('2 flashcards', flashcards);
		setSelfCreated(false);
		setShowCreateOptions(false);
		setAICreated(false);
	};

	return (
		<MathJaxContext
			config={{
				tex: {
					inlineMath: [['\\(', '\\)']],
					displayMath: [['\\[', '\\]']],
				},
			}}
			version={3}
			renderMode="post" // <-- important!
		>
			<div className="flashcard-container">
				{showCreateOptions && activeBoxId === boxId ? (
					<div className="container_options">
						<div className="button-container">
							<div className="button" onClick={() => handleCreateFlashcard('self')}>
								<span className="text">T</span>
							</div>
							<p className="flsahCardCreatText">Create Yourself</p>
						</div>
						<div className="button-container">
							<div className="button" onClick={() => handleCreateFlashcard('ai')}>
								<span className="text">AI</span>
							</div>
							<p className="flsahCardCreatText">Generate Using AI</p>
						</div>
					</div>
				) : selfCreated ? (
					<SelfCreateFlashcard
						boxId={boxId}
						topicId={topicId}
						subtopicId={subtopicId}
						userId={userId}
						notebookId={notebookId}
						subject={subject}
						subtopicName={subtopicName}
						topicName={topicName}
						onFlashcardSaved={handleFlashcardSaved}
						setShowCreateOptions={setShowCreateOptions}
					/>
				) : aiCreated ? (
					<AICreatedFlashcard
						topicId={topicId}
						subtopicId={subtopicId}
						notebookId={notebookId}
						onFlashcardSaved={handleFlashcardSaved}
						setShowFlashcardForm={setShowFlashcardForm}
						setAICreated={setAICreated}
						setFlashcardFormData={setFlashcardFormData}
						boxId={boxId}
						setShowCreateOptions={setShowCreateOptions}
						ai_content_data={ai_content_data}
					/>
				) : showFlashcardForm && flashcardFormData.length > 0 ? (
					<FlashcardForm
						boxId={boxId}
						topicId={topicId}
						subtopicId={subtopicId}
						userId={userId}
						notebookId={notebookId}
						subject={subject}
						subtopicName={subtopicName}
						topicName={topicName}
						flashcardFormData={flashcardFormData}
						setIsAIGeneratedSaved={setIsAIGeneratedSaved}
						flashcards={flashcards}
						setFlashcards={setFlashcards}
						setShowFlashcardForm={setShowFlashcardForm}
						setShowCreateOptions={setShowCreateOptions}
					/>
				) : (
					flashcards.length > 0 && (
						<React.Fragment>
							<div
								className={`flashcard ${isFlipped ? 'flipped' : ''} ${
									slideDirection === 'left'
										? 'slide-in-left'
										: slideDirection === 'right'
										? 'slide-in-right'
										: ''
								}`}
								ref={(el) => {
									flashcardRef.current = el;
									contentRef.current = el; // <- for MathJax targeting
								}}
								onClick={() => setIsFlipped(!isFlipped)}
								onAnimationEnd={() => setSlideDirection('')}
							>
								<div className="flashcard-content">
									<div>
										{flashcards[currentIndex]?.content?.type ===
											'AI Generated' &&
											!isFlipped && (
												<div className="ai-label-container">
													<AutoAwesomeIcon className="ai-icon" />
													<span className="ai-text">AI generated</span>
												</div>
											)}
										{flashcards[currentIndex]?.content?.type ===
											'Self Created' &&
											!isFlipped && (
												<div className="ai-label-container">
													<img
														src={userIcon}
														alt="icon"
														className="user-profile-icon"
													/>
													<span className="ai-text">{firstName}</span>
												</div>
											)}
										<div className="flashcard-inner">
											{!isFlipped ? (
												<div className="flashcard-front">
													<div className="flashcard-text">
														{flashcards[currentIndex]?.content?.front ||
															''}
													</div>
												</div>
											) : (
												<div
													className="flashcard-back"
													style={{
														paddingTop: isOverflowing ? '5%' : '15%',
													}}
												>
													<div className="flashcard-text" ref={textRef}>
														{flashcards[currentIndex]?.content?.back ||
															''}
													</div>
												</div>
											)}
										</div>
									</div>
								</div>
								<button
									className="create-new-flashcard"
									onClick={(e) => {
										e.stopPropagation();
										handleCreateNew(boxId);
									}}
								>
									Create New
								</button>
							</div>

							<div className="navigation-flashcard">
								<FaAngleDoubleLeft
									className={`nav-icon-flashcard ${
										currentIndex === 0 ? 'disabled' : ''
									}`}
									onClick={currentIndex === 0 ? null : handleSkipToFirst}
								/>

								<FaChevronLeft
									className={`nav-icon-flashcard ${
										currentIndex === 0 ? 'disabled' : ''
									}`}
									onClick={handlePrevious}
								/>
								<span style={{ fontWeight: 'bold' }}>
									{currentIndex + 1}/{flashcards.length}
								</span>
								<FaChevronRight
									className={`nav-icon-flashcard ${
										currentIndex === flashcards.length - 1 ? 'disabled' : ''
									}`}
									onClick={handleNext}
								/>
								<FaAngleDoubleRight
									className={`nav-icon-flashcard ${
										currentIndex === flashcards.length - 1 ? 'disabled' : ''
									}`}
									onClick={
										currentIndex === flashcards.length - 1
											? null
											: handleSkipToLast
									}
								/>
							</div>
						</React.Fragment>
					)
				)}
			</div>
		</MathJaxContext>
	);
};

export default Flashcard;
